const operationsMg = {
  state: {
    updateNavKey: ""
  },
  mutations: {
    UPDATE_NAV_ARR: state => {
      state.updateNavKey = new Date().getTime();
    }
  },
  actions: {
    updateNavArr({ commit }) {
      commit("UPDATE_NAV_ARR");
    }
  }
};

export default operationsMg;
